import React from "react";
import DateRange from "../Components/DateRange";
import ReportsDownloadForm from "../containers/ReportsDownloadForm";

export const renderDateRange = ({
  input,
  singleDatePicker,
  onSelect,
  date
}) => (
    <DateRange
      input
      onChange={input.onChange}
      className="custom-datepicker__input"
      id="session-datepicker"
      singleDatePicker={singleDatePicker}
      times={date ? date.split(",").join(".") : ""}
    />
  );

export const renderReportsData = ({
  input,
  index,
  filmName,
  schedule,
  amount,
  money
}) => (
    <ReportsDownloadForm
      input
      onChange={input.onChange}
      index={index}
      filmName={filmName}
      schedule={schedule}
      amount={amount}
      money={money}
    />
  );

export const extendStyles = (isSingle = true) => {
  let styles = {
    control: styles => ({
      ...styles,
      cursor: "pointer",
      backgroundColor: "transparent",
      borderColor: "rgba(255, 255, 255, 0.2)"
    }),
    input: styles => ({
      ...styles,
      color: "white",
      cursor: "text"
    }),
    placeholder: styles => ({
      ...styles,
      color: "#bbbbbb",
      fontFamily: "Roboto-Light, Arial, sans-serif"
    }),
    option: styles => ({
      ...styles,
      color: "#000",
      fontFamily: "Roboto-Light, Arial, sans-serif",
      cursor: "pointer"
    }),

  }

  if (isSingle) {
    Object.assign(styles, {
      singleValue: styles => ({
        ...styles,
        color: "#ffffff",
        fontFamily: "Roboto-Light, Arial, sans-serif",
        fontSize: "16px",
        backgroundColor: "transparent",
        border: "none"
      })
    })
  } else {
    Object.assign(styles, {
      multiValue: styles => ({
        ...styles,
        backgroundColor: "transparent",
        border: "none"
      }),
      multiValueLabel: styles => ({
        ...styles,
        color: "#fff",
        fontFamily: "Roboto-Light, Arial, sans-serif",
        fontSize: "16px",
        padding: "0",
        paddingLeft: "0"
      }),
      multiValueRemove: styles => ({ display: "none" })
    })
  }

  return styles;
}





// WEBPACK FOOTER //
// ./src/helpers/formComponent.js